import React from 'react';
import { useTranslation } from 'next-i18next';
import DentalFindings from 'src/components/icons/DentalFindings';
import Periodontium from 'src/components/icons/Periodontium';
import VisitationHistory from 'src/components/icons/VisitationHistory';
import XRays from 'src/components/icons/XRays';
const usePersonSummary = personSummary => {
  const {
    t
  } = useTranslation();
  return [{
    Icon: /*#__PURE__*/React.createElement(DentalFindings, null),
    title: t('b2c.home.dentalFindings.heading'),
    text: t('b2c.home.dentalFindings.text'),
    active: !!personSummary?.hasJawFindings,
    link: '/record'
  }, {
    Icon: /*#__PURE__*/React.createElement(VisitationHistory, null),
    title: t('b2c.home.visitationDetails.heading'),
    text: t('b2c.home.visitationDetails.text'),
    active: !!personSummary?.hasPatientHistory,
    link: '/record/timeline'
  }, {
    Icon: /*#__PURE__*/React.createElement(XRays, null),
    title: t('b2c.home.xRayImaging.heading'),
    text: t('b2c.home.xRayImaging.text'),
    active: !!personSummary?.hasImages,
    link: '/record/imaging'
  }, {
    Icon: /*#__PURE__*/React.createElement(Periodontium, null),
    title: t('b2c.home.periodontium.heading'),
    text: t('b2c.home.periodontium.text'),
    active: !!personSummary?.hasPsiDiagnosis,
    link: '/record/gums'
  }];
};
export default usePersonSummary;